//bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import Bao from "services/bao-template-engine";
ko.bindingHandlers.baoTemplate = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () { });
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var update = function () {
            var templateName = ko.utils.unwrapObservable(valueAccessor().name);
            var data = ko.utils.unwrapObservable(valueAccessor().data);
            if (valueAccessor().data == undefined) {
                data = viewModel;
            }
            $(element).children().each(function (index) {
                ko.cleanNode($(element).children()[index]);
            });
            $(element).empty();
            if (templateName != null && data != null && Bao.Templates[templateName] != null) {
                $(element).html(Bao.Templates[templateName]);
                var childContext = bindingContext.createChildContext(viewModel);
                ko.applyBindingsToDescendants(data, element);
            }
        };
        update();
        return {
            controlsDescendantBindings: true
        };
    }
};